import useBasket from '~/services/shop/hooks/basket/useBasket';

export default function useBasketReference() {
    return useBasket((data) => data.basketReference);
}
